<template>
  <div v-b-tooltip.hover :title="tooltip[hook]" class="action">
    <b-input-group prepend="防御値" append="" class="length">
      <b-form-input v-model="innerValue.args.Guard" 
        type="number" min="1" max="1000" number />
    </b-input-group>
    <b-button variant="danger" size="sm"
      @click="$emit('remove')">
      <b-icon icon="x" />
    </b-button>
  </div>
</template>

<script>
import Hook from './Hook'
export default {
  extends: Hook
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-flex;
  flex-wrap: nowrap;
}
.length {
  display: inline-flex;
  flex-wrap: nowrap;
}
.buff {
  display: inline-block;
  width: 75px;
}
</style>